import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 20 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.086 1.284h1.87l.032.08 5.917 15.466.064.17h-2.362l-.029-.082-1.446-3.965H3.827l-1.426 3.964-.029.083H0l.064-.169L5.97 1.364l.031-.08zm3.349 9.751L6.98 4.292l-2.446 6.743zm3.54.567 2.464-6.506h1.183L20 14h-1.462l-.816-2.255h-3.38l-.633 1.772zm4.308-1.073L16.03 7.062l-1.245 3.467z"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
